export default __webpack_public_path__ + "static/media/europe.01ee5ebd.svg";